import React, { useState, useEffect } from 'react';
import { MapPin } from 'lucide-react';
import styles from './LocationLoadingScreen.module.css';
import logo from '../../assets/logo2.svg';
import LottieIcon from "../LottieIcon/LottieIcon";

const LoadingScreen = ({businessLoading}) => {



    return (
        <div className={styles.container}>
            <div className={`flex flex-col justify-between h-[237px] z-10 relative`}>
                {!businessLoading && (
                    <div className={`flex flex-col items-center pt-9`}>
                        <div className={styles.iconWrapper}>
                            <MapPin size={48} color="white"/>
                        </div>
                        <div className={`${styles.text}`}>
                            Locating deals near you...
                        </div>
                    </div>

                )}
                <div className={`${styles.logoContainer} flex flex-col items-center gap-3 w-full mt-3`}>
                    <img src={logo} alt="Pluug Logo"/>

                    <span>Hang tight for 5-8s while we load deals for you!</span>
                </div>
            </div>

            <div className={`flex justify-center flex-col items-center p-4 text-center relative z-10`}>

                {businessLoading && <div className={styles.text}>Loading dispensary...</div>}


                <div className={styles.spinner}></div>

                {!businessLoading && (
                    <div className={`${styles.text} text-sm mt-10 relative z-10`} style={{
                        minHeight: '4rem',  // Set a min height to prevent layout shifts
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        transition: 'opacity 0.5s ease-in-out',
                        opacity: 1
                    }}>
                    </div>
                )}
            </div>
            <div className={`absolute w-full h-full top-0 left-0 flex flex-col justify-center items-center z-0`}>
                <LottieIcon variant={`dealsLottie`} className={`w-full h-full ${styles.lottieMap}`}/>
            </div>
        </div>
    );
};

export default LoadingScreen;
